import { combineReducers, configureStore } from "@reduxjs/toolkit";
import activeTabSlice from "./activeTabSlice";
import showModal from "./showModalSlice";
import loginSlice from "./loginSlice";
import userDataSlice from "./userDataSlice";

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import localStorage from "redux-persist/es/storage";

const persistConfig = {
  key: "root",
  version: 1,
  storage: localStorage,
  // Persist ONLY the userData slice so the logged-in admin session survives a
  // page refresh (PrivateRoute gates on state.userDataSlice.userData). The old
  // config used blacklist: ["modal", "shop", "login", "user"], but those names
  // never matched the actual combineReducers keys below (e.g. the reducer key
  // is "userDataSlice", not "user"), so persistence was effectively unreliable
  // and reloads bounced the admin to /login. Whitelisting the exact reducer key
  // makes the session restore deterministic on reload.
  // Security trade-off: this stores the user record (and the auth tokens held
  // in the userData slice) in localStorage, which is readable by any script on
  // the origin (XSS exposure). Acceptable here for session persistence; the
  // tokens should be short-lived / refreshable.
  whitelist: ["userDataSlice"],
};
const reducer = combineReducers({
  activeTab: activeTabSlice,
  showModal: showModal,
  loginSlice: loginSlice,
  userDataSlice: userDataSlice,
});

const persistedReducer = persistReducer(persistConfig, reducer);
const configureAppStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default configureAppStore;
